import * as Tooltip from '@radix-ui/react-tooltip'
import React from 'react'
import styled, { css } from 'styled-components'
import WasteTypePlaceholderIcon from '../icons/WasteTypePlaceholderIcon'

export interface IWasteTypeIconProps {
  name: string
  picture?: string
  disabled?: boolean
  showLabel?: boolean
}

const WasteTypeIcon: React.FC<IWasteTypeIconProps> = ({ name, picture, disabled, showLabel = false }) => {
  return (
    <Container data-testid="wasteIcon-container" data-text={name}>
      <Tooltip.Provider>
        <Tooltip.Root>
          <Tooltip.Trigger>
            {picture ? (
              <PictureWrapper disabled={disabled} picture={picture} />
            ) : (
              <SvgWrapper disabled={disabled}>
                <WasteTypePlaceholderIcon />
              </SvgWrapper>
            )}
          </Tooltip.Trigger>
          <TooltipContent>{name}</TooltipContent>
        </Tooltip.Root>
      </Tooltip.Provider>
      {showLabel && <NameWrapper>{name}</NameWrapper>}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  row-gap: 4px;
`

const NameWrapper = styled.div`
  font-size: 8px;
  text-align: center;
  max-width: 70px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export interface IPictureWrapperProps {
  picture: string
  disabled?: boolean
}

const PictureWrapper = styled.div<IPictureWrapperProps>`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.color.primary};
  background-image: ${({ picture }) => `url(${picture})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  ${({ disabled }) =>
    disabled &&
    css`
      filter: grayscale(100%);
    `}
`

export interface ISvgWrapperProps {
  disabled?: boolean
}

const SvgWrapper = styled.div<ISvgWrapperProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${({ theme }) => theme.color.primary};
  border-radius: 50%;

  svg {
    path {
      fill: ${({ theme }) => theme.color.primary};
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      filter: grayscale(100%);
    `}
`

const TooltipContent = styled(Tooltip.Content)`
  border-radius: 4px;
  padding: 10px 15px;
  font-size: ${({ theme }) => theme.size.smaller};
  color: ${({ theme }) => theme.color.black};
  background-color: ${({ theme }) => theme.color.background};
  box-shadow: hsl(206 22% 7% / 35%) 0 10px 38px -10px, hsl(206 22% 7% / 35%) 0 10px 20px -15px;
`

export default WasteTypeIcon
